import { useWindowContext } from "./WindowContext";
import { WindowFrame } from "./WindowFrame";

/**
 * Renders all tracked windows floating on the desktop.
 * Lives inside Win95Desktop, outside the Outlet.
 */
export function WindowLayer() {
  const {
    windows,
    contentCache,
    focusWindow,
    minimizeWindow,
    closeWindow,
    moveWindow,
    resizeWindow,
    toggleMaximize,
  } = useWindowContext();

  return (
    <>
      {windows.map((win) => {
        const content = contentCache.current.get(win.path);
        return (
          <WindowFrame
            key={win.path}
            win={win}
            title={win.title}
            onFocus={() => focusWindow(win.path)}
            onMinimize={() => minimizeWindow(win.path)}
            onMaximize={() => toggleMaximize(win.path)}
            onClose={() => closeWindow(win.path)}
            onMove={(x, y) => moveWindow(win.path, x, y)}
            onResize={(w, h) => resizeWindow(win.path, w, h)}
          >
            {content ?? null}
          </WindowFrame>
        );
      })}
    </>
  );
}
